import { render } from "./house.vue?vue&type=template&id=ce407962&scoped=true"
import script from "./house.vue?vue&type=script&lang=js"
export * from "./house.vue?vue&type=script&lang=js"

import "./house.vue?vue&type=style&index=0&id=ce407962&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce407962"]])

export default __exports__